import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { FilterChip } from "../models/filter-chip";

@Injectable({ providedIn: 'root' })
export class FilterChipUtilityService {
  constructor(private router: Router) {
  }

  updateUrlWithFilters(filters: FilterChip[], servicePath: string, skipEvents: boolean = false) {
    const queryParams = filters.filter(f => f.chip != null).reduce((acc, cur) => {
      if (cur.isNegated) {
        acc[`filter.not.${cur.chip}`] = cur.value;
      } else {
        acc[`filter.${cur.chip}`] = cur.value;
      }
      return acc;
    }, <any>{});
    if (filters.find(f => f.chip == null)) {
      queryParams["filter.keywords"] = filters.filter(f => f.chip == null).reduce((acc, cur) => acc + ' ' + cur.value.trim(), '');
    }
    this.router.navigate([servicePath], {
      queryParams,
      //skipLocationChange: true,
      replaceUrl: true,
      info: { skipEvents }
    });
  }
}